import script from "./BugManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./BugManagement.vue?vue&type=script&setup=true&lang=js"

import "./BugManagement.vue?vue&type=style&index=0&id=077a98e7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-077a98e7"]])

export default __exports__